export default __webpack_public_path__ + "static/media/income.9af0548f.svg";